import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Chip,
  Paper,
  Typography,
  Box,
} from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import GroupIcon from '@mui/icons-material/Group'

export interface InProgressInvitationsTableRow {
  communityKey: number
  communityName: string
  total: number
}

export interface InProgressInvitationsTableProps {
  rows: InProgressInvitationsTableRow[]
}

export const InProgressInvitationsTable: React.FC<
  InProgressInvitationsTableProps
> = ({ rows }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (rows.length === 0) {
    return (
      <Box p={2}>
        <Typography color="textSecondary" align="center">
          {t(
            'TeamLeaderDashboard.InProgressInvitationsTable.NoResults',
            'No Results Found'
          )}
        </Typography>
      </Box>
    )
  }

  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden', borderRadius: 2 }}>
      <List disablePadding>
        {rows.map((row, index) => (
          <ListItem
            key={row.communityKey}
            disablePadding
            divider={index < rows.length - 1}
          >
            <ListItemButton
              onClick={() =>
                navigate(
                  `/communities/community-details/${row.communityKey}/invites?status=InProgress`
                )
              }
              sx={{ py: 2 }}
            >
              <ListItemIcon>
                <GroupIcon color="primary" />
              </ListItemIcon>

              <ListItemText
                primary={row.communityName}
                primaryTypographyProps={{
                  variant: 'subtitle1',
                  fontWeight: 500,
                  color: 'primary.dark',
                }}
              />

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Chip
                  label={t(
                    'TeamLeaderDashboard.InProgressInvitationsTable.CountLabel',
                    '{{count}} In Progress',
                    { count: row.total }
                  )}
                  color="warning"
                  variant="outlined"
                  size="small"
                  sx={{ fontWeight: 'bold', cursor: 'pointer' }}
                />
                <ChevronRightIcon color="action" />
              </Box>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Paper>
  )
}

export default InProgressInvitationsTable
